import { MenuItem } from "./menu.model";

export const MENU: MenuItem[] = [
  {
    id: 1,
    label: "General",
    showItem: false,
    icon: "bx-store",
    subItems: [
      {
        id: 11,
        label: "Emails",
        link: "/emails-openai",
        parentId: 1,
        code: "EM003",
        showItem: false,
      },
    ],
  }
];
